import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

const checklists = combineReducers({
  data,
  ui,
});

export type ChecklistsReducer = ReturnType<typeof checklists>;

export default checklists;
